import cloneDeep from 'lodash/fp/cloneDeep';
import { createQuotePayload } from './factory/insurance';
import { provideService } from '../services/provider';

const initialInsuranceVehicle = {
  year: '',
  make: '',
  model: '',
};

const initialState = {
  isQuoteLoading: false,
  showQuoteLoading: false,
  updateLeadVehicles: {
    insurance: cloneDeep(initialInsuranceVehicle),
  },
  insurance: {
    price: null,
    distance: null,
    hasWinterTires: null,
    gender: null,
    maritalStatus: null,
    insuranceVehicle: cloneDeep(initialInsuranceVehicle),
    insuranceVehicleOptions: {
      years: [],
      makes: [],
      models: [],
    },
  },
  responseData: null,
  quotes: {},
};

const getters = {
  isQuoteLoading: state => state.isQuoteLoading,
  showQuoteLoading: state => state.showQuoteLoading,
  getResponseData: state => state.responseData,
  getInsuranceVehicleDetails:
    state => `${state.insurance.insuranceVehicle.year} ${state.insurance.insuranceVehicle.make} ${state.insurance.insuranceVehicle.model}
  `,
};
const mutations = {
  SET_VEHICLE_PRICE(state, data) {
    state.insurance.price = data;
  },
  SET_ONE_WAY_DISTANCE(state, data) {
    state.insurance.distance = data;
  },
  SET_HAS_WINTER_TIRES(state, data) {
    state.insurance.hasWinterTires = data;
  },
  SET_GENDER(state, data) {
    state.insurance.gender = data;
  },
  SET_MARITAL_STATUS(state, data) {
    state.insurance.maritalStatus = data;
  },
  SET_IS_QUOTE_LOADING(state, data) {
    state.isQuoteLoading = data;
  },
  SET_SHOW_QUOTE_LOADING(state, data) {
    state.showQuoteLoading = data;
  },
  SET_RESPONSE_DATA(state, data) {
    state.responseData = data;
  },
  SET_QUOTES_DATA(state, data) {
    state.quotes = data;
  },
  SET_INSURANCE_VEHICLE(state, { year, make, model }) {
    state.insurance.insuranceVehicle.year = year;
    state.insurance.insuranceVehicle.make = make;
    state.insurance.insuranceVehicle.model = model;
  },
  SET_LEAD_INSURANCE_VEHICLE(state) {
    state.updateLeadVehicles.insurance = state.insurance.insuranceVehicle;
  },
};
const actions = {
  async getQuote(context) {
    const { commit, rootGetters, rootState } = context;

    // Get payload
    const payload = createQuotePayload(context);
    const isDemo = rootState.business.info.isDemo || process.env.VUE_APP_APP_ENV === 'test';

    const insuranceService = provideService({
      product: 'insurance',
      isDemo,
    });
    const res = await insuranceService.completeQuote(payload);
    const insuranceResponse = rootGetters['business/getThisIsAmerica'] ? 'turboRaterResponse' : 'ezInsureResponse';
    const { Prices } = res.data[insuranceResponse].price;
    commit('SET_QUOTES_DATA', Prices);
    commit('SET_RESPONSE_DATA', res.data[insuranceResponse]);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
